/**
 * Cache widoku profilu (wiersz users + statystyki aktywności) dla popupu profilu.
 * Skraca powtórne otwarcia tego samego użytkownika i wspiera stale-while-revalidate.
 */
const CACHE_TTL_MS = 3 * 60 * 1000;

const store = new Map();

/**
 * @param {string} userId
 * @returns {{ profile: object, stats: object } | null}
 */
export function getCachedProfileView(userId) {
  if (!userId) return null;
  const row = store.get(userId);
  if (!row) return null;
  if (Date.now() - row.savedAt > CACHE_TTL_MS) {
    store.delete(userId);
    return null;
  }
  return { profile: row.profile, stats: row.stats };
}

/**
 * @param {string} userId
 * @param {object} profile
 * @param {object} stats
 */
export function setCachedProfileView(userId, profile, stats) {
  if (!userId || !profile) return;
  store.set(userId, {
    profile,
    stats,
    savedAt: Date.now(),
  });
}

/** Po edycji profilu / jawnej nieważności danych. */
export function invalidateProfileViewCache(userId) {
  if (userId) store.delete(userId);
}
